import React, { useEffect, useRef } from 'react';

import { IModalProps } from './Types';

import './ModalBig.scss';

const Modal: React.FC<IModalProps> = ({ close, children }): JSX.Element => {
  const ref = useRef<HTMLDivElement>();

  const handleClickOutside = (e: any) => {
    if (ref && !ref.current.contains(e.target)) {
      close();
    }
  };

  useEffect(() => {
    document.body.classList.add('fixed');
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.body.classList.remove('fixed');
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);
  return (
    <div className="modal-wrapper">
      <div className="modal-container">
        <div className="modal-content" ref={ref}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
